import { Box, Grid, MenuItem, Divider } from "@mui/material";
import {
  RHFRoundedTextField,
  RHFMultiLineTextField,
  RHFRoundedSelect,
  RHFUpload,
  RHFSwitch,
} from "../../../components/minimal/hook-form";
import { IFormProps } from "types/form-props";
import RHFDatePicker from "components/minimal/hook-form/rhf-date-picker";
import { MEDIA_TYPES_OPTIONS } from "./challenge-column";
import useApiServices from "api/useApiServices";
import { HOST_API } from "config-global";
import { useState } from "react";
import { useSnackbar } from "notistack";
import * as tus from "tus-js-client";

interface ChallengeFormProps extends IFormProps {}

const ChallengeForm: React.FC<ChallengeFormProps> = ({
  currentItem,
  setValue,
}) => {
  const [mediaType, setMediaType] = useState(currentItem?.type ?? "IMAGE");
  const [chunkSize, setChunkSize] = useState(Infinity);
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const { useGetListApi, usePostApi } = useApiServices();
  const { enqueueSnackbar } = useSnackbar();

  const { data: challengeCategoriesList } = useGetListApi<any>({
    url: `${HOST_API}/api/admin/challenge-categories`,
  });

  const createVideo = usePostApi({
    url: "/api/admin/create-video",
    onSuccess: (data: any) => {},
  });

  return (
    <>
      <Grid item xs={12}>
        <RHFRoundedSelect
          name="challengeCategory"
          size="small"
          label="Category"
          disabled={!!currentItem}
        >
          <MenuItem>None</MenuItem>
          <Divider sx={{ borderStyle: "dashed" }} />
          {challengeCategoriesList?.items?.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </RHFRoundedSelect>
      </Grid>

      <Grid item xs={6}>
        <RHFDatePicker
          name="startDate"
          label="Start Date"
          minDate={new Date()}
          format="dd/MM/yyyy"
        />
      </Grid>
      <Grid item xs={6}>
        <RHFDatePicker
          name="endDate"
          label="End Date"
          minDate={new Date()}
          format="dd/MM/yyyy"
        />
      </Grid>

      <Grid item xs={6}>
        <RHFRoundedTextField name="title" label="Title (En)" />
      </Grid>

      <Grid item xs={6}>
        <RHFRoundedTextField name="titleAr" label="Title (Ar)" />
      </Grid>

      <Grid item xs={6}>
        <RHFMultiLineTextField
          name="description"
          label="Description (En)"
          multiline
          rows={4}
        />
      </Grid>

      <Grid item xs={6}>
        <RHFMultiLineTextField
          name="descriptionAr"
          label="Description (Ar)"
          multiline
          rows={4}
        />
      </Grid>

      <Grid item xs={12}>
        <RHFUpload //Replace to RHFUpload
          name="coverImage"
          // file={file}
          onDrop={(acceptedFiles) => {
            const newFile = Object.assign(acceptedFiles[0], {
              preview: URL.createObjectURL(acceptedFiles[0]),
            });
            setValue("coverImage", newFile);
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <RHFRoundedSelect
          name="type"
          size="small"
          label="Media Type"
          defaultValue={mediaType}
          onChange={(type) => {
            setMediaType(type.target.value);
            setValue("type", type.target.value);
          }}
        >
          <MenuItem>None</MenuItem>
          <Divider sx={{ borderStyle: "dashed" }} />
          {MEDIA_TYPES_OPTIONS.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.value}
            </MenuItem>
          ))}
        </RHFRoundedSelect>
      </Grid>

      <Grid item xs={12}>
        <RHFUpload //Replace to RHFUpload
          name="media"
          accept={mediaType == "IMAGE" ? { "image/*": [] } : { "video/*": [] }}
          type={mediaType}
          // file={file}
          onDrop={async (acceptedFiles) => {
            if (mediaType === "VIDEO") {
              // Make the API call to create a video

              // const responseCreateVideo: any = await createVideo.mutateAsync(
              //   {}
              // );
              // setValue("media", responseCreateVideo.VideoId);
              // Handle success response

              const file = Object.assign(acceptedFiles[0], {
                preview: URL.createObjectURL(acceptedFiles[0]),
              });
              setValue("media", file);
              // setChunkSize(Infinity);

              // var options = {
              //   endpoint: "https://video.bunnycdn.com/tusupload/",
              //   chunkSize: chunkSize, // refers to the size of individual chunks into which a file is divided before being transmitted to the server.
              //   retryDelays: [0, 1000, 3000, 5000, 10000, 20000, 60000, 60000],
              //   parallelUploads: 1,
              //   headers: {
              //     AuthorizationSignature:
              //       responseCreateVideo.AuthorizationSignature, // SHA256 signature (library_id + api_key + expiration_time + video_id)
              //     AuthorizationExpire: responseCreateVideo.AuthorizationExpire, // Expiration time as in the signature,
              //     VideoId: responseCreateVideo.VideoId, // The guid of a previously created video object through the Create Video API call
              //     LibraryId: responseCreateVideo.LibraryId, // BUNNY LIBRARY ID >> 160614
              //   },
              //   metadata: {
              //     fileName: file.name,
              //     filetype: file.type,
              //   },
              //   onError: (error: any) => {
              //     enqueueSnackbar("Upload error: " + error, {
              //       variant: "error",
              //     });
              //     setFormLoading(false);
              //   },
              //   onProgress: (bytesUploaded: any, bytesTotal: any) => {
              //     const percentage = (
              //       (bytesUploaded / bytesTotal) *
              //       100
              //     ).toFixed(2);
              //     // Progress tracking logic
              //   },
              //   onSuccess: () => {
              //     // handleRequest(data, formData);
              //   },
              // };

              // const newUpload = new tus.Upload(file, options);
              // // setUpload(newUpload);
              // newUpload.findPreviousUploads().then((previousUploads) => {
              //   // askToResumeUpload(previousUploads, newUpload);
              //   newUpload.start();
              //   // setUploadIsRunning(true);
              // });
            } else {
              // Handle other types of challenges
              // Make the API call to create/update the challenge
              // await handleRequest(data, formData);

              const newFile = Object.assign(acceptedFiles[0], {
                preview: URL.createObjectURL(acceptedFiles[0]),
              });

              setValue("media", newFile);
            }
          }}
        />
      </Grid>

      <Box sx={{ mt: 3 }}>
        <RHFSwitch name="published" label="Published" />
      </Box>
    </>
  );
};

export default ChallengeForm;
